import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  SELECT_SIGNATURE_BUTTON: `${cleanedFilename(
    __filename,
  )}-select-signature-button`,
};
